import { render, staticRenderFns } from "./SmListBudget.vue?vue&type=template&id=a0257b8a&scoped=true&"
import script from "./SmListBudget.vue?vue&type=script&lang=ts&"
export * from "./SmListBudget.vue?vue&type=script&lang=ts&"
import style0 from "./SmListBudget.vue?vue&type=style&index=0&id=a0257b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0257b8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
